import * as angular from 'angular';
import * as app from './app';

export function bootstrap() {
    let bootstrapping = false;

    window.startAngular = function() {
        if (window.location.hash === '#!') {
            // Angular reloads the entire page if hash is "#!"
            window.location.hash = '';
        }
        if (app && !bootstrapping) { // reference app so the import won't be erased as unused
            bootstrapping = true;
            angular.bootstrap(document, ['app'], {strictDi: true});
        }
    };

    window.startRegistration = false;
    window.registrationLoading = true;

    var $pageContent = document.getElementById('page-content');
    var $termsCheckbox = document.getElementById('user-input-terms-accept');
    var $termsProceedButton = document.getElementById('terms-accepted-proceed');

    function handleTermsCheckbox() {
        if ($termsCheckbox.checked) {
            $termsProceedButton.removeAttribute('disabled');
        } else {
            $termsProceedButton.setAttribute('disabled', true);
        }
    }

    if ($termsCheckbox) {
        handleTermsCheckbox();
        $termsCheckbox.addEventListener('change', handleTermsCheckbox, true);
    }

    window.startRegistration = function() {
        window.startRegistration = true;
        if (window.startAngular) {
            window.startAngular();
        }
        $pageContent.className = 'loading';
    };
    window.registrationLoadFinished = function() {
        $pageContent.className = 'loaded';
    };

    $termsProceedButton.addEventListener( 'click', function() {
        window.startRegistration();
    });

    if (window.firsthand.termsAccepted) {
        window.startRegistration();
    }
    if (window.startRegistration === true) {
        window.startAngular();
    }
}
